import React from "react";

export const FONT_FAMILIES = [
  { label: "Font Family", value: "" },
  { label: "Arial", value: "Arial, sans-serif" },
  { label: "Times New Roman", value: "'Times New Roman', serif" },
  { label: "Georgia", value: "Georgia, serif" },
  { label: "Courier New", value: "'Courier New', monospace" },
  { label: "Verdana", value: "Verdana, sans-serif" },
];

/** Font-family combo widget — the `custom()` escape hatch, same as TableGridPicker. */
export function FontFamilyPicker({
  value,
  disabled,
  onSelect,
}: {
  value: string | null;
  disabled?: boolean;
  onSelect: (value: string) => void;
}) {
  return (
    <div className="px-4 py-1.5">
      <select
        aria-label="Font Family"
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => onSelect(e.target.value)}
        className="w-full text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 disabled:text-gray-400 dark:disabled:text-gray-500 disabled:bg-gray-50 dark:disabled:bg-gray-800"
      >
        {FONT_FAMILIES.map((f) => (
          <option key={f.label} value={f.value}>
            {f.label}
          </option>
        ))}
      </select>
    </div>
  );
}
